module.exports = __webpack_public_path__ + "img/20210618_153619.64abba41.jpg";